<template>
    <kgr-generic-modal
        v-if="showDialog"
        :value="showDialog"
        :headline="headline"
        :width-in-px="800"
        scrollable
        @post-input="closeDialog()"
    >
        <kgr-loading
            v-show="loading"
            inline
        />
        <div
            v-show="!loading"
            class="kgr-row"
            style="min-height: 250px;"
        >
            <input
                v-model="search"
                type="text"
                class="kgr-input search"
                :placeholder="$t('search')"
            />
            <table class="kgr-table kgr-table--striped kgr-table--block">
                <thead>
                    <tr class="kgr-table__row">
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('club.exam.result.examinee') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('offering.exam') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('action') }}
                        </th>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('club.exam.result.status') }}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="isDogExam">
                    <tr
                        v-for="(row, index) in filteredDogResultRows"
                        :key="index"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            <span v-if="examOffering.canViewDogs">
                                <a
                                    :href="dogResultsUrl(row.dog.id)"
                                    class="kgr-link"
                                >{{ row.dog.name }}</a>
                                <span> / </span>
                                <a
                                    :href="memberAccountingUrl(row.dog.memberId)"
                                    class="kgr-link"
                                >{{ row.dog.memberName }}</a>
                            </span>
                            <span v-else>{{ row.dog.name }} / {{ row.dog.memberName }}</span>
                        </td>
                        <td class="kgr-table__cell">
                            <ul
                                v-for="result in row.result"
                                :key="result.id"
                                class="mb"
                            >
                                <li :title="titleEditExam">
                                    <a
                                        v-if="examOffering.canEditClubExam"
                                        :href="clubExamEditUrl(result.clubExam.id)"
                                        class="kgr-link"
                                    >{{ result.clubExam.title }}</a>
                                    <span v-else>{{ result.clubExam.title }}</span>
                                </li>
                            </ul>
                        </td>
                        <td class="kgr-table__cell">
                            <ul
                                v-for="result in row.result"
                                :key="result.id"
                            >
                                <li
                                    v-if="result.status === null"
                                    :title="titleCreateExam"
                                >
                                    <a @click="createDogExamResult(row.dog.id, result.clubExam.id)">
                                        <kgr-icon
                                            icon-class="add"
                                            class="pointer"
                                        />
                                    </a>
                                </li>
                                <li
                                    v-else
                                    :title="titleEditExamResult"
                                >
                                    <a @click="loadClubExamResult(result.id)">
                                        <kgr-icon
                                            icon-class="edit"
                                            small
                                            class="pointer"
                                        />
                                    </a>
                                    <a
                                        :title="titleDeleteExamResult"
                                        @click="deleteClubExamResult(result.id)"
                                    >
                                        <kgr-icon
                                            icon-class="delete"
                                            small
                                            class="pointer"
                                        />
                                    </a>
                                </li>
                            </ul>
                        </td>
                        <td class="kgr-table__cell">
                            <ul
                                v-for="result in row.result"
                                :key="result.id"
                                class="mb"
                            >
                                <li v-if="result.status">
                                    {{ $t('club.exam.result.status.' + result.status) }}
                                    <span style="position: relative; top: -3px;">
                                        <kgr-exam-result-status-icon
                                            :exam-result="result"
                                            hide-text
                                            tiny-icons
                                            inline
                                        />
                                    </span>
                                </li>
                                <li v-else>
                                    {{ tNoExamResult }}
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr
                        v-for="(row, index) in filteredMemberResultRows"
                        :key="index"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            <a
                                v-if="row.member.isShortProfileViewable"
                                :href="memberResultsUrl(row.member.id)"
                                class="kgr-link"
                            >{{ row.member.fullName() }}</a>
                            <span v-else>{{ row.member.fullName() }}</span>
                        </td>
                        <td class="kgr-table__cell">
                            <ul
                                v-for="result in row.result"
                                :key="result.id"
                                class="mb"
                            >
                                <li :title="titleEditExam">
                                    <a
                                        v-if="examOffering.canEditClubExam"
                                        :href="clubExamEditUrl(result.clubExam.id)"
                                        class="kgr-link"
                                    >{{ result.clubExam.title }}</a>
                                    <span v-else>{{ result.clubExam.title }}</span>
                                </li>
                            </ul>
                        </td>
                        <td class="kgr-table__cell">
                            <ul
                                v-for="result in row.result"
                                :key="result.id"
                            >
                                <li
                                    v-if="result.status === null"
                                    :title="titleCreateExam"
                                >
                                    <a
                                        @click="createMemberExamResult(row.member.id, result.clubExam.id)"
                                    >
                                        <kgr-icon
                                            icon-class="add"
                                            class="pointer"
                                        />
                                    </a>
                                </li>
                                <li v-else>
                                    <a
                                        v-if="result.isEditable"
                                        :title="titleEditExamResult"
                                        @click="loadClubExamResult(result.id)"
                                    >
                                        <kgr-icon
                                            icon-class="edit"
                                            small
                                            class="pointer"
                                        />
                                    </a>
                                    <a
                                        v-if="result.isDeletable"
                                        :title="titleDeleteExamResult"
                                        @click="deleteClubExamResult(result.id)"
                                    >
                                        <kgr-icon
                                            icon-class="delete"
                                            small
                                            class="pointer"
                                        />
                                    </a>
                                </li>
                            </ul>
                        </td>
                        <td class="kgr-table__cell">
                            <ul
                                v-for="result in row.result"
                                :key="result.id"
                                class="mb"
                            >
                                <li v-if="result.status">
                                    {{ $t('club.exam.result.status.' + result.status) }}
                                    <span style="position: relative; top: -3px;">
                                        <kgr-exam-result-status-icon
                                            :exam-result="result"
                                            hide-text
                                            tiny-icons
                                            inline
                                        />
                                    </span>
                                </li>
                                <li v-else>
                                    {{ tNoExamResult }}
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <template #footer>
            <kgr-button
                class="kgr-col"
                @click="closeDialog()"
            >
                {{ $t('close') }}
            </kgr-button>
        </template>
        <kgr-exam-result-dialog
            ref="examResultDialog"
            :selected-club-exam-result="selectedClubExamResult"
            @close="closeResult()"
        />
    </kgr-generic-modal>
</template>

<script>
import ClubExamResult from '../../../js/dto/club/ClubExamResult.js'
import ClubExamResultRepository from '../../../js/repository/club/ClubExamResultRepository.js'
import DogRepository from '../../../js/repository/DogRepository.js'
import ExamResultDialog from './ExamResultDialog.vue'
import ExamResultStatusIcon from '../../exams/ExamResultStatusIcon.vue'
import GenericModal from '../../common/modal/GenericModal.vue'
import Icon from '../../common/icon/Icon.vue'
import KgrButton from '../../common/form/button/KgrButton.vue'
import Loading from '../../common/Loading.vue'
import MemberRepository from '../../../js/repository/MemberRepository.js'
import Offering from '../../../js/dto/offering/Offering';
import OfferingAppointment from '../../../js/dto/offering/OfferingAppointment.js'
import {format} from '@legacy/js/date/date-fns.js';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-exam-result-dialog': ExamResultDialog,
        'kgr-exam-result-status-icon': ExamResultStatusIcon,
        'kgr-generic-modal': GenericModal,
        'kgr-icon': Icon,
        'kgr-loading': Loading,
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        clubExams: {
            type: Array,
            required: true,
        },
        offeringBookings: {
            type: Array,
            required: true,
        },
        appointment: {
            type: OfferingAppointment,
            required: true,
        },
        examOffering: {
            type: Offering,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            pending: false,
            examResults: [],
            selectedClubExamResult: null,
            search: '',
            resultRows: [],
        }
    },
    computed: {
        isDogExam() {
            return this.examOffering.isExamForDogs();
        },
        members() {
            return this.offeringBookings.map(offeringBooking => offeringBooking.member);
        },
        filteredMemberResultRows() {
            let resultRows = this.resultRows;
            if (this.searchString.length > 0) {
                resultRows = resultRows.filter(row => {
                    return row.member.fullName().toLowerCase().includes(this.searchString);
                });
            }
            return resultRows;
        },
        memberIds() {
            return this.members.map(member => member.id);
        },
        memberParams() {
            return {
                examIds: this.examIds,
                memberIds: this.memberIds,
                startDate: this.formatStart,
                endDate: this.formatEnd,
            }
        },
        dogs() {
            let dogs = [];
            this.offeringBookings.forEach(offeringBooking => {
                if (offeringBooking.dog) {
                    let dog = Object.assign({}, offeringBooking.dog);
                    dog.memberId = offeringBooking.member.id;
                    dog.memberName = offeringBooking.member.fullName();
                    dogs.push(dog);
                }
            });
            return dogs;
        },
        filteredDogResultRows() {
            let resultRows = this.resultRows;
            if (this.searchString.length > 0) {
                resultRows = resultRows.filter(row => {
                    return row.dog.name.toLowerCase().includes(this.searchString) || row.dog.memberName.toLowerCase().includes(this.searchString);
                });
            }
            return resultRows;
        },
        dogIds() {
            return this.dogs.map(dog => dog.id);
        },
        examIds() {
            return this.clubExams.map(clubExam => clubExam.id);
        },
        dogParams() {
            return {
                examIds: this.examIds,
                dogIds: this.dogIds,
                startDate: this.formatStart,
                endDate: this.formatEnd,
            }
        },
        headline() {
            return this.$t('Prüfungsergebnisse erfassen');
        },
        formatStart() {
            return format(new Date(this.appointment.start.date), 'dd.MM.yyyy')
        },
        formatEnd() {
            return format(new Date(this.appointment.end.date), 'dd.MM.yyyy')
        },
        titleEditExamResult() {
            return this.$t('Prüfungsergebnis bearbeiten')
        },
        titleDeleteExamResult() {
            return this.$t('Prüfungsergebnis löschen')
        },
        titleCreateExam() {
            return this.$t('Prüfungsergebnis erstellen')
        },
        titleEditExam() {
            return this.$t('Prüfung bearbeiten');
        },
        searchString() {
            return this.search.trim().toLowerCase();
        },
        tNoExamResult() {
            return this.$t('club.exam.result.status.none');
        },
    },
    watch: {
        showDialog() {
            if (this.showDialog && this.offeringBookings.length > 0) {
                this.reload();
            }
        },
    },
    methods: {
        reload(loading = true) {
            if (this.isDogExam) {
                this.loadDogExamResults(loading);
            } else {
                this.loadMemberExamResults(loading);
            }
        },
        loadClubExamResult(examId) {
            this.$refs.examResultDialog.openDialog();
            ClubExamResultRepository.findById(examId)
                .then(examResult => {
                    this.selectedClubExamResult = examResult;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        loadMemberExamResults(loading) {
            loading ? this.loading = true : this.pending = true;
            ClubExamResultRepository.findByClubIdAndExamineeIds(this.clubId, this.memberParams)
                .then(response => {
                    this.examResults = response;
                    this.setMemberResultRows();
                })
                .finally(() => loading ? this.loading = false : this.pending = false);
        },
        loadDogExamResults(loading) {
            loading ? this.loading = true : this.pending = true
            ClubExamResultRepository.findByClubIdAndExamineeIds(this.clubId, this.dogParams)
                .then(response => {
                    this.examResults = response;
                    this.setDogResultRows();
                })
                .finally(() => loading ? this.loading = false : this.pending = false);
        },
        closeDialog() {
            this.$emit('closeDialog');
        },
        closeResult() {
            this.selectedClubExamResult = null;
            this.reload(false);
        },
        getExamResults(examineeId) {
            const selectedClubExamIds = this.isDogExam ? this.getSelectedExamIdsByDogId(examineeId) : this.getSelectedExamIdsByMemberId(examineeId);
            const examResults = this.examResults.filter(examResult => {
                if (this.isDogExam) {
                    return examResult.dog.id === examineeId
                }
                return examResult.member.id === examineeId;
            });
            this.clubExams.forEach(clubExam => {
                if (selectedClubExamIds.includes(clubExam.id) && examResults.filter(examResult => examResult.clubExam.id === clubExam.id).length === 0) {
                    let newExamResult = new ClubExamResult();
                    newExamResult.clubExam = clubExam;
                    examResults.push(newExamResult);
                }
            })
            return examResults;
        },
        createMemberExamResult(memberId, clubExamId) {
            if (this.pending) {
                return;
            }
            this.pending = true;
            MemberRepository.createMemberExam(memberId, clubExamId, this.examOffering.id, this.formatStart)
                .then(examResultId => {
                    this.loadClubExamResult(examResultId)
                })
                .catch(() => this.$notify.error('Prüfung konnte nicht angelegt werden'))
                .finally(() => this.pending = false);
        },
        memberResultsUrl(memberId) {
            return `/backend/clubs/members/${memberId}/exams`;
        },
        memberAccountingUrl(memberId) {
            return `/backend/clubs/members/${memberId}/accounting/fee-assignment`;
        },
        setMemberResultRows() {
            let rows = [];
            const members = this.members;
            members.forEach(member => {
                const row = {
                    member: member,
                    result: this.getExamResults(member.id)
                }
                rows.push(row);
            })
            this.resultRows = rows;
        },
        createDogExamResult(dogId, clubExamId) {
            if (this.pending) {
                return;
            }
            this.pending = true;
            DogRepository.createDogExam(dogId, clubExamId, this.examOffering.id, this.formatStart)
                .then(examResultId => {
                    this.loadClubExamResult(examResultId)
                })
                .catch(() => this.$notify.error('Prüfung konnte nicht angelegt werden'))
                .finally(() => this.pending = false);
        },
        dogResultsUrl(dogId) {
            return `/backend/clubs/dogs/${dogId}/exams`;
        },
        setDogResultRows() {
            let rows = [];
            const dogs = this.dogs;
            dogs.forEach(dog => {
                const row = {
                    dog: dog,
                    result: this.getExamResults(dog.id)
                }
                rows.push(row);
            })
            this.resultRows = rows;
        },
        clubExamEditUrl(clubExamId) {
            return `/backend/clubs/${this.clubId}/exams/edit/${clubExamId}`;
        },
        deleteClubExamResult(clubExamResultId) {
            showConfirm(this.$t('confirmInformal'), this.$t('Möchtest du das Prüfungsergebnis wirklich löschen?'), () => {
                ClubExamResultRepository.delete(clubExamResultId)
                    .then(() => {
                        this.$notify.success('Das Prüfungsergebnis wurde gelöscht');
                        this.reload(false);
                    })
                    .catch(() => this.$notify.error('Das Prüfungsergebnis konnte nicht gelöscht werden'));
            });
        },
        getSelectedExamIdsByDogId(dogId) {
            return this.offeringBookings.filter(offeringBooking => offeringBooking.dog && offeringBooking.dog.id === dogId)[0].selectedClubExams.map(clubExam => clubExam.id);
        },
        getSelectedExamIdsByMemberId(memberId) {
            return this.offeringBookings.filter(offeringBooking => offeringBooking.member && offeringBooking.member.id === memberId)[0].selectedClubExams.map(clubExam => clubExam.id);
        },
    },
}
</script>

<style scoped lang="scss">
.pointer {
    cursor: pointer;
}
.search {
    width: 200px;
    margin-bottom: 15px;
}
ul.mb > li {
    margin-bottom: 5px;
}
</style>
